import { StatusMessage } from '../models/index';

export const CATEGORY_ALL = 'All';

export const MESSAGE_MAX_CHARS = 300; 
export const MAX_MESSAGES = 150; 

export const LOGIN_WITH_TOKEN = 'LOGIN_WITH_TOKEN';
export type LOGIN_WITH_TOKEN = typeof LOGIN_WITH_TOKEN;

export const LOGIN_WITH_QUERY_PARAM = 'LOGIN_WITH_QUERY_PARAM';
export type LOGIN_WITH_QUERY_PARAM = typeof LOGIN_WITH_QUERY_PARAM;

export const AUTH_REQUEST = 'AUTH_REQUEST';
export type AUTH_REQUEST = typeof AUTH_REQUEST;

export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export type AUTH_SUCCESS = typeof AUTH_SUCCESS;

export const AUTH_RENEW_SUCCESS = 'AUTH_RENEW_SUCCESS';
export type AUTH_RENEW_SUCCESS = typeof AUTH_RENEW_SUCCESS;

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export type LOGOUT_REQUEST = typeof LOGOUT_REQUEST;

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export type LOGOUT_SUCCESS = typeof LOGOUT_SUCCESS;

export const AUTH_POPUP_CLOSE = 'AUTH_POPUP_CLOSE';
export type AUTH_POPUP_CLOSE = typeof AUTH_POPUP_CLOSE;


export const AUTH_POPUP_CLOSE_SUCCESS = 'AUTH_POPUP_CLOSE_SUCCESS';
export type AUTH_POPUP_CLOSE_SUCCESS = typeof AUTH_POPUP_CLOSE_SUCCESS;

export const AUTH_FAILURE = 'AUTH_FAILURE';
export type AUTH_FAILURE = typeof AUTH_FAILURE;

export const SHOW_ADD_MESSAGE_SECTION = 'SHOW_ADD_MESSAGE_SECTION';
export type SHOW_ADD_MESSAGE_SECTION = typeof SHOW_ADD_MESSAGE_SECTION;

export const HIDE_ADD_MESSAGE_SECTION = 'HIDE_ADD_MESSAGE_SECTION';
export type HIDE_ADD_MESSAGE_SECTION = typeof HIDE_ADD_MESSAGE_SECTION;

export const ADD_MESSAGE_REQUEST = 'ADD_MESSAGE_REQUEST';
export type ADD_MESSAGE_REQUEST = typeof ADD_MESSAGE_REQUEST;

export const ADD_MESSAGE_SUCCESS = 'ADD_MESSAGE_SUCCESS';
export type ADD_MESSAGE_SUCCESS = typeof ADD_MESSAGE_SUCCESS;

export const ADD_MESSAGE_FAILURE = 'ADD_MESSAGE_FAILURE';
export type ADD_MESSAGE_FAILURE = typeof ADD_MESSAGE_FAILURE;

export const EDIT_MESSAGE_TEMPLATE = 'EDIT_MESSAGE_TEMPLATE';
export type EDIT_MESSAGE_TEMPLATE = typeof EDIT_MESSAGE_TEMPLATE;


export const SHOW_EDIT_MESSAGES_VIEW = 'SHOW_EDIT_MESSAGES_VIEW';
export type SHOW_EDIT_MESSAGES_VIEW = typeof SHOW_EDIT_MESSAGES_VIEW;

export const HIDE_EDIT_MESSAGES_VIEW = 'HIDE_EDIT_MESSAGES_VIEW';
export type HIDE_EDIT_MESSAGES_VIEW = typeof HIDE_EDIT_MESSAGES_VIEW;

export const DELETE_MESSAGE_REQUEST = 'DELETE_MESSAGE_REQUEST';
export type DELETE_MESSAGE_REQUEST = typeof DELETE_MESSAGE_REQUEST;

export const DELETE_MESSAGE_SUCCESS = 'DELETE_MESSAGE_SUCCESS';
export type DELETE_MESSAGE_SUCCESS = typeof DELETE_MESSAGE_SUCCESS;

export const DELETE_MESSAGE_FAILURE = 'DELETE_MESSAGE_FAILURE';
export type DELETE_MESSAGE_FAILURE = typeof DELETE_MESSAGE_FAILURE;

export const VIEW_MESSAGES_REQUEST = 'VIEW_MESSAGES_REQUEST';
export type VIEW_MESSAGES_REQUEST = typeof VIEW_MESSAGES_REQUEST;

export const VIEW_MESSAGES_SUCCESS = 'VIEW_MESSAGES_SUCCESS';
export type VIEW_MESSAGES_SUCCESS = typeof VIEW_MESSAGES_SUCCESS;

export const MESSAGES_CATEGORY_DATA = 'MESSAGES_CATEGORY_DATA';
export type MESSAGES_CATEGORY_DATA = typeof MESSAGES_CATEGORY_DATA;

export const VIEW_MESSAGES_FAILURE = 'VIEW_MESSAGES_FAILURE';
export type VIEW_MESSAGES_FAILURE = typeof VIEW_MESSAGES_FAILURE;

export const MESSAGES_PREV_PAGE = 'MESSAGES_PREV_PAGE';
export type MESSAGES_PREV_PAGE = typeof MESSAGES_PREV_PAGE;

export const MESSAGES_NEXT_PAGE = 'MESSAGES_NEXT_PAGE';
export type MESSAGES_NEXT_PAGE = typeof MESSAGES_NEXT_PAGE;
export const SEARCH_MESSAGE_REQUEST = 'SEARCH_MESSAGE_REQUEST';
export type SEARCH_MESSAGE_REQUEST = typeof SEARCH_MESSAGE_REQUEST;

export const SEARCH_MESSAGE_SUCCESS = 'SEARCH_MESSAGE_SUCCESS';
export type SEARCH_MESSAGE_SUCCESS = typeof SEARCH_MESSAGE_SUCCESS;

export const APPLICATION_NAME = 'CannedMessages';

export const RESET_MESSAGE_STATE = 'RESET_MESSAGE_STATE';
export type RESET_MESSAGE_STATE = typeof RESET_MESSAGE_STATE;

export const EDIT_MESSAGE_REQUEST = 'EDIT_MESSAGE_REQUEST';
export type EDIT_MESSAGE_REQUEST = typeof EDIT_MESSAGE_REQUEST;

export const EDIT_MESSAGE_SUCCESS = 'EDIT_MESSAGE_SUCCESS';
export type EDIT_MESSAGE_SUCCESS = typeof EDIT_MESSAGE_SUCCESS;

export const EDIT_MESSAGE_FAILURE = 'EDIT_MESSAGE_FAILURE';
export type EDIT_MESSAGE_FAILURE = typeof EDIT_MESSAGE_FAILURE;

export const COPY_MESSAGE_REQUEST = 'COPY_MESSAGE_REQUEST';
export type COPY_MESSAGE_REQUEST = typeof COPY_MESSAGE_REQUEST;

export const COPY_MESSAGE_SUCCESS = 'COPY_MESSAGE_SUCCESS';
export type COPY_MESSAGE_SUCCESS = typeof COPY_MESSAGE_SUCCESS;

export const COPY_MESSAGE_FAILURE = 'COPY_MESSAGE_FAILURE';
export type COPY_MESSAGE_FAILURE = typeof COPY_MESSAGE_FAILURE;

export const CANCEL_EDIT_MESSAGE = 'CANCEL_EDIT_MESSAGE';
export type CANCEL_EDIT_MESSAGE = typeof CANCEL_EDIT_MESSAGE;

export const SESSION_STARTED = 'SESSION_STARTED';
export type SESSION_STARTED = typeof SESSION_STARTED;

export const DISMISS_MESSAGE_BANNER = 'DISMISS_MESSAGE_BANNER';
export type DISMISS_MESSAGE_BANNER = typeof DISMISS_MESSAGE_BANNER;


export const SORT_MESSAGES_CANCEL_PREV_REQUEST = 'SORT_MESSAGES_CANCEL_PREV_REQUEST';
export type SORT_MESSAGES_CANCEL_PREV_REQUEST = typeof SORT_MESSAGES_CANCEL_PREV_REQUEST;

export const SORT_MESSAGES_REQUEST = 'SORT_MESSAGES_REQUEST';
export type SORT_MESSAGES_REQUEST = typeof SORT_MESSAGES_REQUEST;

export const SORT_MESSAGES_INMEMORY = 'SORT_MESSAGES_INMEMORY';
export type SORT_MESSAGES_INMEMORY = typeof SORT_MESSAGES_INMEMORY;

export const SORT_MESSAGES_SUCCESS = 'SORT_MESSAGES_SUCCESS';
export type SORT_MESSAGES_SUCCESS = typeof SORT_MESSAGES_SUCCESS;

export const SORT_MESSAGES_FAILURE = 'SORT_MESSAGES_FAILURE';
export type SORT_MESSAGES_FAILURE = typeof SORT_MESSAGES_FAILURE;

export const CATEGORY_SORT_MESSAGES_CANCEL_PREV_REQUEST = 
'CATEGORY_SORT_MESSAGES_CANCEL_PREV_REQUEST';
export type CATEGORY_SORT_MESSAGES_CANCEL_PREV_REQUEST = 
typeof CATEGORY_SORT_MESSAGES_CANCEL_PREV_REQUEST;

export const CATEGORY_SORT_MESSAGES_REQUEST = 'CATEGORY_SORT_MESSAGES_REQUEST';
export type CATEGORY_SORT_MESSAGES_REQUEST = typeof CATEGORY_SORT_MESSAGES_REQUEST;

export const CATEGORY_SORT_MESSAGES_INMEMORY = 'CATEGORY_SORT_MESSAGES_INMEMORY';
export type CATEGORY_SORT_MESSAGES_INMEMORY = typeof CATEGORY_SORT_MESSAGES_INMEMORY;

export const CATEGORY_SORT_MESSAGES_SUCCESS = 'CATEGORY_SORT_MESSAGES_SUCCESS';
export type CATEGORY_SORT_MESSAGES_SUCCESS = typeof CATEGORY_SORT_MESSAGES_SUCCESS;

export const CATEGORY_SORT_MESSAGES_FAILURE = 'CATEGORY_SORT_MESSAGES_FAILURE';
export type CATEGORY_SORT_MESSAGES_FAILURE = typeof CATEGORY_SORT_MESSAGES_FAILURE;

export const TAG_ADDED = 'TAG_ADDED';
export type TAG_ADDED = typeof TAG_ADDED;

export const TAG_ADD_SUCCESS = 'TAG_ADD_SUCCESS';
export type TAG_ADD_SUCCESS = typeof TAG_ADD_SUCCESS;

export const TAG_ADD_FAILURE = 'TAG_ADD_FAILURE';
export type TAG_ADD_FAILURE = typeof TAG_ADD_FAILURE;

export const CATEGORY_EXPAND = 'CATEGORY_EXPAND';
export type CATEGORY_EXPAND = typeof CATEGORY_EXPAND;

export const CATEGORY_COLLAPSED = 'CATEGORY_COLLAPSED';
export type CATEGORY_COLLAPSED = typeof CATEGORY_COLLAPSED;


export const messageSavedSuccessfullyText = `Your message has been saved.`;
export const messageDeletedSuccessfullyText = `Message has been deleted.`;
export const success = 'Success!';
export const error = 'Whoops! Something went wrong';
export const saving = 'Saving message...';
export const deleting = 'Deleting message...';


export const messageSaveSuccessful: StatusMessage = {
  header: success, 
  message: messageSavedSuccessfullyText, 
  status: 'success',
  icon: 'check circle',
  timeout: 2000,
};

export const messageSaving: StatusMessage = {
  header: saving,
  status: 'request',
  color: 'blue',
  icon: 'circle notched',
};

export const messageDeleteSuccessful: StatusMessage = {
  header: success, 
  message: messageDeletedSuccessfullyText, 
  status: 'success',
  icon: 'check circle',
  timeout: 2000,
};

export const messageDeleting: StatusMessage = {
  header: deleting,
  status: 'request',
  color: 'blue',
  icon: 'circle notched',
};

export const messageError: StatusMessage = {
  header: error,
  status: 'error',
  icon: 'exclamation circle',
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/index.ts